import React, { memo } from 'react';
import { FormHTML } from '@core/components/form/FormHTML';
import { FormControl, FormGroup } from '@core/utils/form';

export interface BlockTemplateBlockSettingsProps {
  terms?: FormControl<string>;
  form?: FormGroup<any>;
}

export const BlockTemplateBlockSettings = memo((props: BlockTemplateBlockSettingsProps) => {
  const { terms } = props;

  return <div>{!!terms && <FormHTML control={terms} minimal />}</div>;
});
